/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Judge.me: force the review header (rating, verified badge, "Write a review"
// button and filter) onto a single line. Uses a stylesheet so the rules survive
// the widget's Vue re-renders instead of racing inline-style overrides.
function injectJudgeMeHeaderStyles() {
  if (document.getElementById('jm-header-oneline-styles')) return;
  const style = document.createElement('style');
  style.id = 'jm-header-oneline-styles';
  style.textContent = [
    /* the whole header row */
    '#judgeme_product_reviews .jm-review-widget__header,',
    '#judgeme_product_reviews .jm-review-widget__header > .jm-cluster {',
    '  display: flex !important;',
    '  flex-flow: row nowrap !important;',
    '  align-items: center !important;',
    '  gap: 16px !important;',
    '  width: 100% !important;',
    '}',
    /* every nested cluster/stack in the header must stay a single row */
    '#judgeme_product_reviews .jm-review-widget-minimal-header__filter-container,',
    '#judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters,',
    '#judgeme_product_reviews .jm-action-buttons,',
    '#judgeme_product_reviews .jm-average-rating-display,',
    '#judgeme_product_reviews .jm-average-rating-display .jm-cluster,',
    '#judgeme_product_reviews .jm-review-widget__header .jm-stack--space-200 > .jm-cluster {',
    '  display: flex !important;',
    '  flex-flow: row nowrap !important;',
    '  align-items: center !important;',
    '  gap: 8px !important;',
    '}',
    /* push the button + filter group to the far right of the row */
    '#judgeme_product_reviews .jm-review-widget-minimal-header__filter-container {',
    '  margin-left: auto !important;',
    '  flex: 0 0 auto !important;',
    '}',
    '#judgeme_product_reviews .jm-review-widget-minimal-header__button-and-filters {',
    '  gap: 12px !important;',
    '}',
    /* keep the pieces from being squeezed / wrapping on narrow screens */
    '#judgeme_product_reviews .jm-review-widget__header .jm-stack--space-200 {',
    '  flex: 0 0 auto !important;',
    '}',
    /* keep "4.8 / 5" and "(192 reviews)" from ever breaking across lines */
    '#judgeme_product_reviews .jm-average-rating-display .jm-text {',
    '  white-space: nowrap !important;',
    '}',
    '#judgeme_product_reviews .jm-action-buttons__button {',
    '  white-space: nowrap !important;',
    '  flex: 0 0 auto !important;',
    '}',
    '#judgeme_product_reviews .jm-review-widget-minimal-header__filters {',
    '  flex: 0 0 auto !important;',
    '}',
    /* hide the "Verified" badge in the rating display */
    '#judgeme_product_reviews .jm-average-rating-display .jm-verified-badge {',
    '  display: none !important;',
    '}',
    /* per-review verified badge: no outline, transparent bg, green "✓ verified" */
    '#judgeme_product_reviews .jm-verified-buyer-badge,',
    '#judgeme_product_reviews .jm-verified-buyer-badge * {',
    '  background: transparent !important;',
    '  background-color: transparent !important;',
    '  border: 0 none !important;',
    '  outline: 0 none !important;',
    '  box-shadow: none !important;',
    '  border-radius: 0 !important;',
    '  padding: 0 !important;',
    '  margin: 0 !important;',
    '  color: #1f8a3b !important;',
    '}',
    /* kill any pill/outline drawn via pseudo-elements on the badge */
    '#judgeme_product_reviews .jm-verified-buyer-badge::before,',
    '#judgeme_product_reviews .jm-verified-buyer-badge::after {',
    '  content: none !important;',
    '  border: 0 none !important;',
    '  box-shadow: none !important;',
    '  background: transparent !important;',
    '  display: none !important;',
    '}',
    /* add a green ✓ before the text */
    '#judgeme_product_reviews .jm-verified-buyer-badge__text::before {',
    '  content: "\\2713\\00a0";',
    '  color: #1f8a3b !important;',
    '}',
    '#judgeme_product_reviews .jm-verified-buyer-badge__text {',
    '  color: #1f8a3b !important;',
    '}',
    /* outlined "Write a review" button: transparent bg, black text and outline */
    '#judgeme_product_reviews .jm-action-buttons__button,',
    '#judgeme_product_reviews .jm-action-buttons__button:hover,',
    '#judgeme_product_reviews .jm-action-buttons__button:focus {',
    '  background: transparent !important;',
    '  background-color: transparent !important;',
    '  border: 1px solid #000 !important;',
    '  color: #000 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);
}

// Judge.me Spacing Override Script
function removeJudgeMeSpacing() {
  const reviewWidget = document.getElementById('judgeme_product_reviews');
  if (!reviewWidget) return;

  // Override CSS custom properties
  const spacingVars = [
    '--jm-space-300',
    '--jm-space-600', 
    '--jm-space-400',
    '--jm-space-200',
    '--jm-space-100',
    '--52156a25'
  ];

  spacingVars.forEach(varName => {
    reviewWidget.style.setProperty(varName, '0px', 'important');
  });

  // Remove spacing from most stack elements but keep some for readability
  const stackElements = reviewWidget.querySelectorAll('[class*="jm-stack"]');
  stackElements.forEach(el => {
    el.style.setProperty('--52156a25', '0px', 'important');
    
    // Keep minimal spacing for header alignment and lay it out on a single row
    if (el.classList.contains('jm-review-widget__header')) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('flex-wrap', 'nowrap', 'important');
      el.style.setProperty('align-items', 'center', 'important');
      el.style.setProperty('gap', '12px', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0 0 8px 0', 'important');
    } else if (el.classList.contains('jm-review-item')) {
      // Add spacing between review items to prevent overlap
      el.style.setProperty('gap', '0', 'important');
      el.style.setProperty('margin', '16px 0', 'important');
      el.style.setProperty('padding', '12px', 'important');
    } else {
      el.style.setProperty('gap', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
    }
  });

  // Fix header alignment
  const headerClusters = reviewWidget.querySelectorAll('.jm-review-widget__header .jm-cluster');
  headerClusters.forEach(cluster => {
    cluster.style.setProperty('align-items', 'center', 'important');
    cluster.style.setProperty('gap', '8px', 'important');
  });

  // Add spacing between review items in the list and fix alignment
  const reviewList = reviewWidget.querySelector('.jdgm-review-list');
  if (reviewList) {
    reviewList.style.setProperty('gap', '20px', 'important');
    reviewList.style.setProperty('margin', '0', 'important');
    reviewList.style.setProperty('padding', '0', 'important');
  }

  // Target individual review boxes for better separation and remove indentation
  const reviewBoxes = reviewWidget.querySelectorAll('.jm-box.jm-review-item');
  reviewBoxes.forEach(box => {
    box.style.setProperty('margin', '0 0 20px 0', 'important');
    box.style.setProperty('padding', '12px 0', 'important');
  });

  // Fix review widget body alignment
  const reviewBody = reviewWidget.querySelector('.jm-review-widget__body');
  if (reviewBody) {
    reviewBody.style.setProperty('margin', '0', 'important');
    reviewBody.style.setProperty('padding', '0', 'important');
  }

  // Show rating out of 5 with review count: "4.8 / 5 (192 reviews)"
  const avgRatingTexts = reviewWidget.querySelectorAll('.jm-average-rating-display .jm-cluster .jm-text');
  if (avgRatingTexts.length >= 1) {
    // Make first text (rating) bold and append "/ 5"
    const ratingText = avgRatingTexts[0];
    ratingText.style.setProperty('--text-weight', 'var(--jm-body-xs-weight-bold)', 'important');
    ratingText.style.setProperty('font-weight', '700', 'important');
    if (!/\/\s*5/.test(ratingText.textContent)) {
      const value = parseFloat(ratingText.textContent);
      if (!isNaN(value)) ratingText.textContent = value + ' / 5';
    }

    // Add parentheses around the review count, keep it visible and enlarge it
    const reviewCountText = avgRatingTexts[1];
    if (reviewCountText) {
      reviewCountText.style.removeProperty('display');
      reviewCountText.style.setProperty('--text-size', 'var(--jm-body-md-size)', 'important');
      reviewCountText.style.setProperty('font-size', '15px', 'important');
      if (!reviewCountText.textContent.includes('(')) {
        reviewCountText.textContent = `(${reviewCountText.textContent})`;
      }
    }
  }

  // Lay out rating, verified badge, "Write a review" button and filter on one row.
  // The outer header cluster holds two groups: [rating] and [button + filter].
  const headerCluster = reviewWidget.querySelector('.jm-review-widget__header > .jm-cluster');
  if (headerCluster) {
    headerCluster.style.setProperty('display', 'flex', 'important');
    headerCluster.style.setProperty('flex-flow', 'row nowrap', 'important');
    headerCluster.style.setProperty('align-items', 'center', 'important');
    headerCluster.style.setProperty('justify-content', 'space-between', 'important');
    headerCluster.style.setProperty('gap', '16px', 'important');
    headerCluster.style.setProperty('width', '100%', 'important');
  }

  // Keep the "Write a review" button and the filter side-by-side (they were
  // wrapping onto separate lines). Force these clusters to a single row.
  const rowGroups = reviewWidget.querySelectorAll(
    '.jm-review-widget-minimal-header__filter-container,' +
    '.jm-review-widget-minimal-header__button-and-filters,' +
    '.jm-action-buttons'
  );
  rowGroups.forEach(function (group) {
    group.style.setProperty('display', 'flex', 'important');
    group.style.setProperty('flex-flow', 'row nowrap', 'important');
    group.style.setProperty('align-items', 'center', 'important');
    group.style.setProperty('gap', '12px', 'important');
  });

  // Keep the filter fixed-size on the row so it never gets squeezed on narrow screens
  const filters = reviewWidget.querySelector('.jm-review-widget-minimal-header__filters');
  if (filters) {
    filters.style.setProperty('width', '34px', 'important');
    filters.style.setProperty('height', '34px', 'important');
    filters.style.setProperty('flex', '0 0 auto', 'important');
    filters.style.setProperty('margin', '0', 'important');
  }

  // Keep the rating group at its natural width so "4.8 / 5 (192 reviews)" never wraps
  const rating = reviewWidget.querySelector('.jm-review-widget__header .jm-stack--space-200');
  if (rating) {
    rating.style.setProperty('flex', '0 0 auto', 'important');
    rating.style.removeProperty('min-width');
  }
  const writeBtn = reviewWidget.querySelector('.jm-action-buttons__button');
  if (writeBtn) {
    writeBtn.style.setProperty('flex', '0 1 auto', 'important');
    writeBtn.style.setProperty('min-width', '0', 'important');
    writeBtn.style.setProperty('white-space', 'nowrap', 'important');
  }

  // Make the dropdown select narrower
  const filterSelect = reviewWidget.querySelector('.jm-sort-filter__select');
  if (filterSelect) {
    filterSelect.style.setProperty('width', '30px', 'important');
    filterSelect.style.setProperty('height', '34px', 'important');
  }

  // Make Judge.me pagination less compact
  const paginationCluster = reviewWidget.querySelector('.jm-pagination-controls .jm-cluster');
  if (paginationCluster) {
    paginationCluster.style.setProperty('--cluster-space', '6px', 'important');
    paginationCluster.style.setProperty('gap', '6px', 'important');
  }

  // Add spacing to pagination buttons
  const paginationButtons = reviewWidget.querySelectorAll('.jm-pagination-controls__button');
  paginationButtons.forEach(button => {
    button.style.setProperty('margin', '0 2px', 'important');
    button.style.setProperty('padding', '9px 9px', 'important');
  });
}

// Fix image progress dots stretching bug
function fixProgressDots() {
  // Add CSS rule to override all possible dot stretching
  let styleSheet = document.getElementById('dot-fix-styles');
  if (!styleSheet) {
    styleSheet = document.createElement('style');
    styleSheet.id = 'dot-fix-styles';
    document.head.appendChild(styleSheet);
  }
  
  styleSheet.textContent = `
    /* Fix dot containers from expanding */
    [class*="pagination"],
    [class*="dots"],
    .product-gallery__pagination,
    .slideshow__pagination,
    .flickity-page-dots,
    .splide__pagination,
    .swiper-pagination {
      width: auto !important;
      max-width: none !important;
      flex-shrink: 0 !important;
      justify-content: center !important;
    }
    
    /* Force all potential dot elements to maintain size */
    [class*="pagination"] button,
    [class*="dots"] button,
    [class*="dot"],
    .product-gallery button,
    .slideshow button,
    .flickity-page-dots .dot,
    .splide__pagination button,
    .swiper-pagination-bullet {
      width: 8px !important;
      height: 8px !important;
      min-width: 8px !important;
      min-height: 8px !important;
      max-width: 8px !important;
      max-height: 8px !important;
      flex-shrink: 0 !important;
      flex-grow: 0 !important;
      flex-basis: 8px !important;
      border-radius: 50% !important;
      transition: none !important;
      transform: none !important;
      box-sizing: border-box !important;
      margin: 2px !important;
    }
    
    /* Override any active/hover states that might stretch */
    [class*="pagination"] button.is-selected,
    [class*="pagination"] button:hover,
    [class*="dots"] button.is-selected,
    [class*="dots"] button:hover,
    [class*="dot"].is-selected,
    [class*="dot"]:hover {
      width: 8px !important;
      height: 8px !important;
      transform: none !important;
    }
  `;
}

// Run when DOM loads and when Judge.me widgets update
injectJudgeMeHeaderStyles();
document.addEventListener('DOMContentLoaded', () => {
  injectJudgeMeHeaderStyles();
  removeJudgeMeSpacing();
  fixProgressDots();
});
document.addEventListener('judgeme:loaded', () => {
  injectJudgeMeHeaderStyles();
  removeJudgeMeSpacing();
});

// Fix dots on scroll and resize events
let scrollTimeout;
window.addEventListener('scroll', () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(fixProgressDots, 50);
});

window.addEventListener('resize', fixProgressDots);

// Use intersection observer to fix dots when they come into view
const dotObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      setTimeout(fixProgressDots, 100);
    }
  });
});

// Observe dot containers
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const dotContainers = document.querySelectorAll('[class*="dots"], [class*="progress-dots"], .product-gallery__pagination, .slideshow__pagination');
    dotContainers.forEach(container => {
      dotObserver.observe(container);
    });
  }, 1000);
});

// Use MutationObserver to handle dynamic content
const observer = new MutationObserver(() => {
  removeJudgeMeSpacing();
});

document.addEventListener('DOMContentLoaded', () => {
  const reviewWidget = document.getElementById('judgeme_product_reviews');
  if (reviewWidget) {
    observer.observe(reviewWidget, { childList: true, subtree: true });
  }
});
